import store from '@/store'

export default [{
  name: 'talks',
  path: '/talks',
  beforeEnter(to, from, next) {
    // 상세 페이지에서 들어오는 게 아니면 목록 비우기
    if (from.name !== 'talks/:uuid') {
      store.dispatch('talks/clear')
    }
    next()
  },
  component: require('@/views/talks/Tab.vue').default
}, {
  name: 'talks/:uuid',
  path: '/talks/:uuid',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/talks/Detail.vue').default
}]
